import { Edit } from 'lucide-react';
import { DynamicIcon, type IconName } from 'lucide-react/dynamic';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { Card as CardType } from '../../service/api/types';
import CardActionsList from '../CardActionsList';

interface ManagerCardPresetCardProps {
  card: CardType;
  onDeliver: (card: CardType) => void;
}

export default function ManagerCardPresetCard({
  card,
  onDeliver,
}: ManagerCardPresetCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCardClick = () => {
    onDeliver(card);
  };

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/manager/card/${card._id}`);
  };

  return (
    <Card
      className="mb-3 shadow-sm border"
      style={{ cursor: 'pointer' }}
      onClick={handleCardClick}
    >
      <Card.Body>
        <Row className="align-items-center">
          <Col xs="auto">
            <DynamicIcon
              name={(card.icon || 'credit-card') as IconName}
              size={32}
              className="text-primary"
            />
          </Col>
          <Col>
            <h6 className="mb-0">{card.title || t('cards.untitledCard')}</h6>
          </Col>
          {card.actions?.length > 0 && (
            <Col xs="auto" className="d-flex align-items-center gap-2">
              <CardActionsList actions={card.actions} size="xs" />
            </Col>
          )}
          <Col xs="auto">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleEdit}
              title={t('common.edit')}
            >
              <Edit size={16} />
            </Button>
          </Col>
        </Row>

        {card.description && (
          <Row className="pt-2">
            <Col>
              <p className="text-muted small mb-0">{card.description}</p>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}
